import { render, staticRenderFns } from "./CloseBadge.vue?vue&type=template&id=20ddb2bc"
import script from "./CloseBadge.vue?vue&type=script&lang=ts"
export * from "./CloseBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports